import { render, staticRenderFns } from "./HLBForm.vue?vue&type=template&id=cfbb8680"
import script from "./HLBForm.vue?vue&type=script&lang=js"
export * from "./HLBForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports